import { Alert } from 'antd';

export function ProdutoTabAdicionalInfo() {
    return (
        <Alert
            description={
                <>
                    <p>
                        Configure itens extras para seus produtos, como adicionais pagos (ex: bacon
                        extra) ou opcionais gratuitos (ex: escolha o tipo de molho).
                    </p>
                    <p>
                        É possível definir se são obrigatórios, se permitem múltiplas seleções e se
                        o valor será somado ao total do produto.
                    </p>
                </>
            }
            showIcon={true}
            type='info'
        />
    );
}
